import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentSolicitacaoFluxoRevisao from './ContentSolicitacaoFluxoRevisao';

const SolicitacaoFluxoRevisao = () => {
  return (
    <div className="d-flex flex-column min-h-screen">
      <HeaderApp />
      <ContentSolicitacaoFluxoRevisao />
      <Bottom />
    </div>
  );
};

export default SolicitacaoFluxoRevisao;
